import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
    render() {
        
        return (
            <div className="footer">
                <div className="footerSidebar"></div>
                <div className="footerMenu">
                    <Link to='/impressum'>Impressum</Link> /&nbsp;
                    <Link to='/datenschutz'>Datenschutz</Link> /&nbsp; 
                    <Link to='/kontakt'>Kontakt</Link>
                    
                    <br /> <span>© 2026 ERB-Kauf GmbH</span>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js